/*global chrome*/
import React from 'react';
import StandardWebcamShare from './StandardShare';

const ShareWebcam = ({ stepData, setIsTaskComplete, setStepMetadata }) => {
  return <StandardWebcamShare stepData={stepData} setIsTaskComplete={setIsTaskComplete} setStepMetadata={setStepMetadata} />;
};

export default ShareWebcam;
